import { useDispatch, useSelector } from "react-redux";
import broadcastsSlice from "./broadcastsSlice";

function useBroadcasts() {
  const { broadcasts, bonusBroadcast } = useSelector((state) => {
    return state.broadcasts;
  });
  const dispatch = useDispatch();

  function setBroadcasts(broadcasts) {
    dispatch(broadcastsSlice.actions.setBroadcasts(broadcasts));
  }

  function setBonusBroadcast(bonusBroadcast) {
    dispatch(broadcastsSlice.actions.setBonusBroadcast(bonusBroadcast));
  }

  return { broadcasts, setBroadcasts, bonusBroadcast, setBonusBroadcast };
}

export default useBroadcasts;
